import { isEmpty } from 'lodash'
import React from 'react'
import { useMobileRecordContext } from '../../contexts/mobileRecordContext'
import RootRecord from "./mobileRecordDisplays/rootRecord"
import ChildRecords from "./mobileRecordDisplays/childRecords"

const MobileRecord = () => {
  const { rootRecord } = useMobileRecordContext()

  return (<>
      {!isEmpty(rootRecord) && (
        <div className='flex flex-row flex-1 bg-gray-100'>
          <RootRecord>
            <ChildRecords map={[rootRecord.uuid]} />
          </RootRecord>
        </div>
      )}
    </>
  )
}
export default MobileRecord
